import { __read, __spreadArray } from "tslib";
import axios from 'axios';
export var axiosClient = axios.create();
export var preAxiosCacheInterceptor = function (config, fetchStrategy) {
    if (fetchStrategy === "cache-only" /* FetchStrategy.CacheOnly */) {
        return Promise.reject('Cache unsupported');
    }
    return Promise.resolve(config);
};
/**
 * Adds interceptors to the xhr request pipeline.
 *
 * @param requestInterceptors - Interceptors run by axios just before sending the request
 * @param responseInterceptors - Interceptors run by axios just after response
 * @param preRequestCacheInterceptor - Interceptor run before axios and allows for custom initialization of requests meant for cached data (setting strategy header, rejecting unhandled requests, etc.). The interceptor should reject if a cache is not supported.
 */
export function addInterceptors(requestInterceptors, responseInterceptors, preRequestCacheInterceptor) {
    requestInterceptors === null || requestInterceptors === void 0 ? void 0 : requestInterceptors.forEach(function (requestInterceptor) {
        var _a;
        (_a = axiosClient.interceptors.request).use.apply(_a, __spreadArray([], __read(requestInterceptor), false));
    });
    responseInterceptors === null || responseInterceptors === void 0 ? void 0 : responseInterceptors.forEach(function (responseInterceptor) {
        var _a;
        (_a = axiosClient.interceptors.response).use.apply(_a, __spreadArray([], __read(responseInterceptor), false));
    });
    if (preRequestCacheInterceptor) {
        preAxiosCacheInterceptor = preRequestCacheInterceptor;
    }
}
//# sourceMappingURL=axiosClient.js.map